import pocketmon from "pokemon-go-pokedex";
import Router from "./Router";
import GlobalStyles from "./GlobalStyles";
function App() {
  
  return (
    <>
      <Router/>
      <GlobalStyles/>
    </>
  );
}

export default App;
